module.exports = __webpack_public_path__ + "static/hackathon-9-040c9d664b4ff85c6b126be1fdea5759.jpg";